<h1 class="h3 mb-2 text-gray-800">Solicitudes</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Lista de Solicitudes</h6>
    </div>
    <div class="card-body">
        <div *ngIf="solicitudes.length==0">
            Necesita insertar un solicitud
        </div>
        <div *ngIf="solicitudes.length > 0" class="table-responsive">
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Información Solicitada</th>
                        <th>Respuesta</th>
                        <th>Requiere Archivos</th>
                        <th>Archivos</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let solicitud of solicitudes">
                        <td>{{solicitud.id}}</td>
                        <td>{{solicitud.texto_solicitud}}</td>
                        <td>{{solicitud.texto_respuesta}}</td>
                        <td>{{getRequiereArchivos(solicitud)}}</td>
                        <td>
                            <div>
                                <a target="_blank" *ngFor="let archivo of solicitud.archivos; let i = index;" style="margin-right: 5px;" [href]="getArchivoLink(archivo, i)" >
                                    {{(i+1)}}
                                </a>
                            </div>
                        </td>
                        <td><a *ngIf="!solicitud.resuelto" [routerLink]="[ '/solicitudes/', solicitud.id ]" class="btn btn-primary">Enviar datos</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>